/** Kill switch: false restores the two-item nav, the TA-only listing and the QuickSight index. */
export const PARTNER_CONSOLIDATED_REPORTS_FLAG = 'partnerConsolidatedReports';
